<template>
    <div class="relative bg-white rounded-lgr border border-valence-grey-250 flex flex-col items-start gap-2 overflow-hidden pt-13.75 pb-10 px-5 text-[#595959]">
        <div class="shrink-0">
            <img :src="CollabProfileIcon" alt="Collaboration Profile" class="h-10.5 w-auto" />
        </div>
        <div class="flex flex-col w-full gap-1.25">
            <div class="text-valence-grey-850 font-serif text-[20px] font-medium leading-6.5">Help your team work better with you</div>
            <div class="text-[13px] leading-5 text-valence-grey-700 mt-0.5">Generate your collaboration profile in seconds</div>
        </div>
        <button
            class="w-full rounded-3xl text-base font-medium text-[#595959] bg-valence-primary-200 hover:bg-valence-primary-300 px-4 py-2 cursor-pointer mt-auto"
            @click="handleClick">
            Generate
        </button>
    </div>
</template>

<script setup lang="ts">
import CollabProfileIcon from "~img/collab-profile-icon.png";
import { openUrl } from "~vue/utils";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted } from "vue";

const props = withDefaults(
    defineProps<{
        hasPerspectiveResult?: boolean;
    }>(),
    { hasPerspectiveResult: false },
);

onMounted(() => logUserInteraction(AmplitudeEventNames.COLLABORATION_PROFILE_CARD_SHOWN));

const handleClick = () => {
    logUserInteraction(AmplitudeEventNames.COLLABORATION_PROFILE_CARD_CLICKED);
    openUrl(props.hasPerspectiveResult ? "/profile/create?auto_generate=true" : "/profile/create");
};
</script>
